import React from 'react';

const IntegrationLogFormModal = React.lazy(() => import('../components/FormModal'));
const integrationLogModalRegistry = {
    personalize_integrationLogId: IntegrationLogFormModal
};
export default integrationLogModalRegistry;
